import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { onMounted, reactive, toRefs, watch } from "vue";
import apis from "@/api";
import common from "../composables/common";
import { Check, Close } from '@element-plus/icons-vue';
import SensitiveWords from "./SensitiveWords";
export default {
  name: "SrcAudit",
  components: {
    SensitiveWords,
    Check,
    Close
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    auditRole: {
      type: Object
    },
    multiSrss: {
      type: Array
    }
  },
  setup(props, context) {
    const {
      getSrcType
    } = common();
    const data = reactive({
      commContents: [],
      sensWordsList: [],
      commContAddShow: false,
      newContent: '',
      saveLoading: false,
      loading: false,
      audit: {
        assetsIds: '',
        approveState: 0,
        aprroveContent: ''
      }
    });
    const close = () => {
      context.emit('update:visible', false);
      data.audit.approveState = 0;
      data.audit.aprroveContent = '';
    };
    const hanldeSave = () => {
      if (!data.audit.aprroveContent) {
        ElMessage.error('请输入审核备注内容');
      } else {
        data.saveLoading = true;
        let srcIds = [];
        props.multiSrss.forEach(s => {
          if (s.srcTyp == '7' && s.multiSms) {
            srcIds.push(s.smsSrcId);
          } else {
            srcIds.push(s.srcId);
          }
        });
        data.audit.assetsIds = srcIds.join(',');
        data.audit.roleId = props.auditRole.roleId;
        data.audit.roleName = props.auditRole.roleName;
        apis.saveSrcAudit(data.audit).then(res => {
          if (res.success) {
            ElMessage({
              type: 'success',
              message: '保存成功'
            });
            context.emit('save');
            data.saveLoading = false;
            close();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    };
    const hanldeSubmit = () => {
      // 审批状态非空校验
      if (data.audit.approveState == 0) {
        ElMessage.error('请选择审批结果');
      } else if (!data.audit.aprroveContent && data.audit.approveState != 1) {
        ElMessage.error('请输入审核备注内容');
      } else {
        data.loading = true;
        let srcIds = [];
        props.multiSrss.forEach(s => {
          if (s.srcTyp == '7' && s.multiSms) {
            srcIds.push(s.smsSrcId);
          } else {
            srcIds.push(s.srcId);
          }
        });
        data.audit.assetsIds = srcIds.join(',');
        data.audit.roleId = props.auditRole.roleId;
        data.audit.roleName = props.auditRole.roleName;
        console.log('data.audit: ', data.audit);
        apis.auditBatch(data.audit).then(res => {
          if (res.success) {
            if (data.audit.roleId == 'yewu' && data.audit.approveState == 1) {
              ElMessage({
                type: 'success',
                message: '素材审核通过，请到素材库进行业务关联！'
              });
            } else {
              ElMessage({
                type: 'success',
                message: '审批成功'
              });
            }
            context.emit('success');
            data.loading = false;
            close();
          } else {
            ElMessage.error(res.msg);
          }
        });
      }
    };
    const getCommContents = () => {
      const {
        aprroveContent
      } = data.audit;
      apis.getAuditComms({
        content: aprroveContent
      }).then(res => {
        if (res.success) {
          data.commContents = res.data;
        }
      });
    };
    const autoCompleteContent = content => {
      data.audit.aprroveContent = content;
    };
    const hanldeCommContAdd = () => {
      const {
        newContent
      } = data;
      apis.addAuditComms({
        content: newContent
      }).then(res => {
        if (res.success) {
          ElMessage.success("常用审核语添加成功");
          data.newContent = '';
          getCommContents();
          data.commContAddShow = false;
        }
      });
    };
    watch(() => props.auditRole.aprroveContent, (val, oldVal) => {
      data.audit.aprroveContent = val;
    });
    watch(() => props.multiSrss, (val, oldVal) => {
      const aids = val.map(s => s.srcId).join(',');
      apis.getSensWordByAssetsIds({
        aids
      }).then(res => {
        if (res.code == 200) {
          data.sensWordsList = res.data;
        }
      });
    });
    onMounted(() => {
      getCommContents();
    });
    return {
      ...toRefs(data),
      getSrcType,
      close,
      hanldeSubmit,
      hanldeSave,
      autoCompleteContent,
      hanldeCommContAdd,
      getCommContents
    };
  }
};